const PLATFORMS = [
  [/iPhone/, 'iPhone'],
  [/iPad/, 'iPad'],
  [/Android/, 'Android'],
  [/CrOS/, 'ChromeOS'],
  [/Windows/, 'Windows'],
  [/Macintosh|Mac OS X/, 'Mac'],
  [/Linux/, 'Linux'],
]

const BROWSERS = [
  [/Edg(e|A|iOS)?\//, 'Edge'],
  [/OPR\/|Opera/, 'Opera'],
  [/SamsungBrowser\//, 'Samsung Internet'],
  [/Firefox\/|FxiOS\//, 'Firefox'],
  [/Chrome\/|CriOS\//, 'Chrome'],
  [/Version\/[\d.]+.*Safari\//, 'Safari'],
]

const match = (list, userAgent) => list.find(([pattern]) => pattern.test(userAgent))?.[1]

export const describeUserAgent = (userAgent) => {
  if (typeof userAgent !== 'string' || !userAgent.trim()) return ''
  const parts = [match(PLATFORMS, userAgent), match(BROWSERS, userAgent)].filter(Boolean)
  return parts.length ? parts.join(' - ') : 'Unknown device'
}
